/**
 * Promo System Utility Functions
 */

import { DROP_OFF_ROUTES, PROMO_CLEAR_ROUTES, CONVERSION_ROUTES_FOR_OTHER_POSTS } from './promoConstants';

/**
 * Check if current path should clear promo code (successful conversion)
 */
export var shouldClearPromoOnRoute = function shouldClearPromoOnRoute(pathname) {
  return PROMO_CLEAR_ROUTES.some(function (route) {
    return pathname.includes(route);
  });
};

/**
 * Check if current path is a conversion route
 */
export var isConversionRoute = function isConversionRoute(pathname) {
  return DROP_OFF_ROUTES.some(function (route) {
    return pathname.includes(route);
  });
};
export var isConversionRouteForOtherPosts = function isConversionRouteForOtherPosts(pathname) {
  return CONVERSION_ROUTES_FOR_OTHER_POSTS.some(function (route) {
    return pathname.includes(route);
  });
};

/**
 * Check if user is on the promo post page
 */
export var isOnPromoPost = function isOnPromoPost(currentPath, storedPostId) {
  if (!storedPostId) return false;
  if (!currentPath) {
    return false;
  }
  return currentPath.includes('/cardetail/') && currentPath.includes(storedPostId);
};

/**
 * Check if user is on shop-apply page for the promo
 */
export var isOnShopApplyPage = function isOnShopApplyPage(currentPath, searchParams, promoPostId) {
  if (!currentPath.includes('/checkout/shop-apply')) return false;
  var postIdFromUrl = searchParams.get('post_id');
  return postIdFromUrl === promoPostId;
};

/**
 * Get comprehensive page context
 */
export var getPageContext = function getPageContext(currentPath, searchParams, promoPostId) {
  var isOnPost = isOnPromoPost(currentPath, promoPostId);
  var isOnShopApply = isOnShopApplyPage(currentPath, searchParams, promoPostId);
  var isOnConversion = isConversionRoute(currentPath) && isOnPost;
  var postIdFromUrl = searchParams.get('post_id');
  var isOnConversionForOtherPromoPosts = isConversionRouteForOtherPosts(currentPath) && !isOnPost;
  return {
    isOnPromoPost: isOnPost,
    isOnShopApplyPage: isOnShopApply,
    isOnConversionPage: isOnConversion,
    isOnConversionForOtherPromoPosts: isOnConversionForOtherPromoPosts,
    currentPath: currentPath,
    postIdFromUrl: postIdFromUrl || undefined
  };
};

/**
 * Check if promo data is valid (not expired)
 */
export var isPromoDataValid = function isPromoDataValid(promoData, expiryString) {
  if (!promoData || !expiryString) {
    return false;
  }
  var expiryDate = new Date(expiryString);
  var now = new Date();
  return now < expiryDate;
};

/**
 * Create shop-apply URL with promo code
 */
export var createShopApplyUrl = function createShopApplyUrl(postId, promoCode) {
  return "/checkout/shop-apply?post_id=".concat(postId, "&promo=").concat(promoCode);
};

/**
 * Format promo event data for analytics
 */
export var formatPromoEventData = function formatPromoEventData(promoCode) {
  return {
    ppc_code: promoCode.code,
    ppc_type: promoCode.promo_type,
    ppc_discount_amount: promoCode.discount_amount,
    ppc_warranty_duration: (promoCode === null || promoCode === void 0 ? void 0 : promoCode.warranty_duration) || 0,
    post_id: promoCode.post_id || null,
    post_make: promoCode.car_details.make || null,
    post_model: promoCode.car_details.model || null,
    post_year: promoCode.car_details.year || null,
    post_condition: promoCode.car_details.condition || null,
    views_count: promoCode.views_count || 0
  };
  /**
   * ppc_type(discount/warranty/shipping)
   * ppc_discount_amount
   * ppc_warranty_duration
   * post_id
   * post_make
   * post_model
   * post_year
   * post_condition
   * views_count(will return the count of views for this car by this user)
   */
};